import { useEffect, useState } from 'react';
import { Spinner, Stack } from 'react-bootstrap';
import { FaArrowLeft } from 'react-icons/fa6';
import { useNavigate, useParams } from 'react-router-dom';
import { SimpleButton } from '../../../../../components/buttons/SimpleButton';
import { DetailSection, LabelText } from '../../../../../components/generic';
import { useToast } from '../../../../../context/ToastContext';
import {
  useGetScholarshipQuery
} from '../../../../../services/endpoints/orders/scholarship';
import { getCurrentUser } from '../../../../../services/helper';
import { Scholarship } from '../../../../../types/orders.type';
import { scholarshipTypes } from '../../../../../utils/consts/orders/scholarships';
import { formatDate } from '../../../../../utils/dateUtils';
import { userCanCreateEdit_Scholarships } from './ScholarshipsView';

export const ScholarshipDetails = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { addToast } = useToast();
  const currentUser = getCurrentUser();
  const { data, error, isLoading } = useGetScholarshipQuery(+params.id!);
  const [scholarship, setScholarship] = useState<Scholarship>();

  useEffect(() => {
    if (error && !isLoading) {
      addToast('Error while loading scholarship', 'error');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error, isLoading]);

  useEffect(() => {
    if (data) {
      setScholarship(data.scholarship);
    }
  }, [data]);

  if (isLoading) {
    return (
      <div className="w-100 vh-100 d-inline-flex">
        <Spinner
          variant="primary"
          className="m-auto"
        />
      </div>
    );
  }

  if (!scholarship) return <></>;

  return (
    <>
      <div
        className="d-flex justify-content-between align-items-center px-lg-5 border-bottom px-4 py-3"
        style={{ background: '#EFEFEF' }}
      >
        <Stack
          direction="horizontal"
          gap={2}
          className="ps-lg-3 ps-0"
        >
          <button
            className="btn btn-link text-info p-0"
            onClick={() => navigate('/admin/orders/scholarships')}
          >
            <FaArrowLeft
              size={20}
              className="d-lg-none"
            />
            <FaArrowLeft
              size={24}
              className="d-none d-lg-block"
            />
          </button>
          <h2
            className="d-lg-none text-secondary fw-semibold text-uppercase mb-0 pt-1"
            style={{ color: '#888888', fontSize: '1rem' }}
          >
            Scholarships List
          </h2>
          <h2 className="d-none d-lg-block text-info fw-bold mb-0">
            {`${scholarshipTypes[scholarship?.scholarship_type]}`}{' '}
            {`(${scholarship?.percent_discount}% off)`}
          </h2>
        </Stack>
        {userCanCreateEdit_Scholarships(currentUser) && (
          <Stack
            direction="horizontal"
            gap={1}
            className="d-none d-lg-flex"
          >
            <SimpleButton
              variant="primary"
              height={36}
              onClick={() => navigate(`/admin/orders/scholarships/${scholarship?.id}/edit`)}
            >
              Edit scholarship
            </SimpleButton>
          </Stack>
        )}
      </div>
      <div>
        <Stack
          gap={4}
          className="p-4"
        >
          <DetailSection>
            <LabelText
              label="Scholarship Type:"
              text={scholarshipTypes[scholarship?.scholarship_type]}
            />
            <LabelText
              label="Percent Discount:"
              text={scholarship?.percent_discount}
            />
            <LabelText
              label="Created At:"
              text={formatDate(new Date(scholarship?.created_at), 'MM/dd/yyyy h:mm a zzz')}
            />
            <LabelText
              label="Updated At:"
              text={formatDate(new Date(scholarship?.updated_at), 'MM/dd/yyyy h:mm a zzz')}
            />
          </DetailSection>
        </Stack>
      </div>
    </>
  );
};
